
import axios from 'axios';
import { getServerError } from '../error/error-service';
import { ApiAttachment } from './attachment-service.types';

const DocApiBaseUrl = `/doc-api`;

export const getAttachmentList = (documentKey: string) => {
    return axios.get<ApiAttachment[]>(`${DocApiBaseUrl}/document/${documentKey}/attachment`)
        .then((response) => {
            return response.data.map(a => ({
                ...a,
                filePath: `/attachments${a.filePath}`,
                isImage: a.data.mimetype.indexOf('image') !== -1,
            }));
        })
        .catch((error) => {
            throw getServerError(error);
        });
}

// Загружаем файлы
export const upload = (documentKey: string, attachments: any[], onUploadProgress: (a: any) => void) => {
    const formData = new FormData();
    attachments.forEach(a => {
        formData.append('attachments', a);
    });

    return axios.post<{ rows: ApiAttachment[] }>(`${DocApiBaseUrl}/document/${documentKey}/upload`, formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
        onUploadProgress,
        // params: {
        //     signOutIgnore: true
        // }
    })
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            throw getServerError(error);
        });
}

export const deleteAttachment = (attachmentUId: string) => {
    return axios.delete(`${DocApiBaseUrl}/attachment/${attachmentUId}`)
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            throw getServerError(error);
        });
}